import script from "./ButtonGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=76ec3e91&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ec3e91"]])

export default __exports__